import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IPackage, IPackageAddon } from '../../../shared/interfaces/packaging.interface';
import { PackageApi } from './rest/package.api';

@Injectable({ providedIn: 'root' })
export class PackageService {
  constructor(private packageApi: PackageApi) {}

  public getPackages(): Observable<IPackage[]> {
    return this.packageApi.getPackages();
  }

  public getUserWayPackages(): Observable<IPackage[]> {
    return this.packageApi.getUserWayPackages();
  }

  public getPackageAddons(forPackage: string): Observable<IPackageAddon[]> {
    return this.packageApi.getPackageAddons(forPackage);
  }
}
